import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import { nittyGritty } from "@/constants/NittyGritty.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      title: nittyGritty.fundsGrantedTitle,
      metaTags: [
        {
          name: "description",
          content:
            "Receive and manage applicable education grants delivered to you daily."
        }
      ]
    }
  },
  {
    path: "/home",
    name: "homealt",
    component: Home,
    meta: {
      title: nittyGritty.fundsGrantedTitle,
      metaTags: [
        {
          name: "description",
          content:
            "Receive and manage applicable education grants delivered to you daily."
        }
      ]
    }
  },
  {
    path: "/accountmanagement/:id?",
    name: "accountmanagement",
    component: () => import("../views/AccountManagement.vue")
  },
  {
    path: "/aboutus",
    name: "aboutus",
    component: () => import("../views/AboutUs.vue"),
    meta: {
      title: nittyGritty.fundsGrantedTitle,
      metaTags: [
        {
          name: "description",
          content:
            "We help educators and administration to find funds that are out there through grants to elevate students' education."
        }
      ]
    }
  },
  {
    path: "/howitworks",
    name: "howitworks",
    component: () => import("../views/HowItWorks.vue"),
    meta: {
      title: nittyGritty.fundsGrantedTitle + " How It Works",
      metaTags: [
        {
          name: "description",
          content:
            "We find education grants for you. You choose which grants to follow. We send reminders about those grants."
        }
      ]
    }
  },
  {
    path: "/mygrants/:id?",
    name: "mygrants",
    component: () => import("../views/MyGrants.vue")
  },
  {
    path: "/myfeed",
    name: "myfeed",
    component: () => import("../views/MyFeed.vue")
  },
  {
    path: "/contactus",
    name: "contactus",
    component: () => import("../views/ContactUs.vue")
  },
  {
    path: "/pricing",
    name: "pricing",
    component: () => import("../views/Pricing.vue")
  },
  {
    path: "/tryforfree",
    name: "tryforfree",
    component: () => import("../views/TryForFree.vue")
  },
  {
    path: "/confirmUser/:id",
    name: "confirmuser",
    component: () => import("../views/ConfirmUser.vue")
  },
  {
    path: "/myhome",
    name: "myhome",
    meta: {
      title: nittyGritty.fundsGrantedTitle
    },
    component: () => import("../views/MyHome.vue")
  },
  {
    path: "/userpreferences",
    name: "userpreferences",
    component: () => import("../views/UserPreferences.vue")
  },
  {
    path: "/signin",
    name: "signin",
    component: () => import("../views/SignIn.vue"),
    meta: {
      title: nittyGritty.fundsGrantedTitle + " Sign In",
      metaTags: [
        {
          name: "description",
          content:
            "Sign in here to get applicable education grants delivered to you daily."
        }
      ]
    }
  },
  {
    path: "/managegrants",
    name: "managegrants",
    component: () => import("../views/ManageGrants.vue")
  },
  {
    path: "/grantsearch",
    name: "grantsearch",
    component: () => import("../views/GrantSearch.vue")
  },
  {
    path: "/calendar",
    name: "calendar",
    component: () => import("../views/Calendar.vue")
  },
  {
    path: "/privacypolicy",
    name: "privacypolicy",
    component: () => import("../views/PrivacyPolicy.vue")
  },
  {
    path: "/instructions",
    name: "instructions",
    component: () => import("../instructionViews/Instructions.vue")
  },
  {
    path: "/individualrequest",
    name: "individualrequest",
    component: () => import("../views/IndividualRequest.vue")
  },
  {
    path: "/schoolrequest",
    name: "schoolrequest",
    component: () => import("../views/SchoolRequest.vue")
  },
  {
    path: "/districtrequest",
    name: "districtrequest",
    component: () => import("../views/DistrictRequest.vue")
  },
  {
    path: "/help",
    name: "help",
    component: () => import("../views/Help.vue")
  },
  {
    path: "/resetpassword",
    name: "resetpassword",
    component: () => import("../views/ResetPassword.vue")
  },
  {
    path: "/myaccount",
    name: "myaccount",
    component: () => import("../views/MyAccount.vue")
  },
  {
    path: "/myorganization",
    name: "myorganization",
    component: () => import("../views/MyOrganization.vue")
  },
  {
    path: "/managetemplates",
    name: "managetemplates",
    component: () => import("../views/ManageTemplates.vue")
  },
  {
    path: "/manageglossary",
    name: "manageglossary",
    component: () => import("../views/ManageGlossary.vue")
  },
  {
    path: "/managefaq",
    name: "managefaq",
    component: () => import("../views/ManageFAQ.vue")
  },
  {
    path: "/manageblog",
    name: "manageblog",
    component: () => import("../views/ManageBlog.vue")
  },
  {
    path: "/managetutorial",
    name: "managetutorial",
    component: () => import("../views/ManageTutorial.vue")
  },
  {
    path: "/blog",
    name: "blog",
    component: () => import("../views/Blog.vue")
  }
];

const router = new VueRouter({
  routes
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
  // This goes through the matched routes from last to first, finding the closest route with a title.
  // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.title);

  // Find the nearest route element with meta tags.
  const nearestWithMeta = to.matched
    .slice()
    .reverse()
    .find(r => r.meta && r.meta.metaTags);
  //const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

  // If a route with a title was found, set the document (page) title to that value.
  if (nearestWithTitle) document.title = nearestWithTitle.meta.title;

  // Remove any stale meta tags from the document using the key attribute we set below.
  Array.from(
    document.querySelectorAll("[data-vue-router-controlled]")
  ).map(el => el.parentNode.removeChild(el));

  // Skip rendering meta tags if there are none.
  if (!nearestWithMeta) return next();

  // Turn the meta tag definitions into actual elements in the head.
  nearestWithMeta.meta.metaTags
    .map(tagDef => {
      const tag = document.createElement("meta");

      Object.keys(tagDef).forEach(key => {
        tag.setAttribute(key, tagDef[key]);
      });

      // We use this to track which meta tags we create, so we don't interfere with other ones.
      tag.setAttribute("data-vue-router-controlled", "");

      return tag;
    })
    // Add the meta tags to the document head.
    .forEach(tag => document.head.appendChild(tag));

  next();
});

export default router;
